import { Button, Card, CardContent, Grid, styled, Typography } from '@material-ui/core';
import React from 'react';

const TitleTypography = styled(Typography)({
  fontFamily: 'Lato',
  fontSize: '14px',
  fontWeight: 600,
  lineHeight: '19.6px',
  color: '#10182B',
});

const SubTitleTypography = styled(Typography)({
  fontFamily: 'Lato',
  lineHeight: '19.6px',
  color: '#667085',
  fontSize: '12px',
  fontWeight: '500',
});

export default function ZeroState({
  Icon,
  text,
  style = {},
  title,
  btnText,
  btnAction,
  cardWidth = '350px',
  type = 'content',
  iconColor,
  bg = '#fff',
}) {
  return type === 'content' ? (
    <Grid container style={style}>
      <Grid
        container
        justifyContent="center"
        alignItems="center"
        style={{
          textAlign: 'center',
          width: '100%',
        }}
      >
        <Card
          style={{
            width: cardWidth,
            textAlign: 'center',
            justifyContent: 'center',
            borderRadius: '8px',
            background: bg,
            padding: '10px',
          }}
        >
          <Icon style={{ marginTop: '30px' }} />
          <CardContent>
            <Grid container direction="column" spacing={1}>
              <Grid item>{title && <TitleTypography>{title}</TitleTypography>}</Grid>
              <Grid item>
                <SubTitleTypography>{text}</SubTitleTypography>
              </Grid>
              <Grid item>
                {btnText && (
                  <Button
                    color="primary"
                    variant="contained"
                    style={{
                      margin: '10px 20px 20px',
                    }}
                    onClick={btnAction}
                  >
                    {btnText}
                  </Button>
                )}
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  ) : (
    <Grid container style={style}>
      <Grid
        style={{
          width: '100%',
          height: '100%',
          border: '1px dashed gray',
          gap: '15px',
        }}
        container
        justifyContent="center"
        alignItems="center"
        direction="column"
      >
        <Icon color={iconColor} />

        <Typography variant="body2" style={{ width: '220px', textAlign: 'center' }}>
          {text}
        </Typography>
      </Grid>
    </Grid>
  );
}
